import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import EmptyState from '../common/EmptyState';

const { FiUsers, FiCheckCircle, FiHeart, FiPlay } = FiIcons;

const ArtistCard = ({ artist, index }) => (
  <Link to={`/${artist.slug}`}
    className="group block bg-zinc-900/50 border border-zinc-800 rounded-3xl overflow-hidden hover:border-brand-pink/40 transition-all duration-500 hover:-translate-y-2 card-lift animate-fade-in"
    style={{ animationDelay: `${index * 100}ms` }}>
    {/* Image container with overlay */}
    <div className="relative aspect-square overflow-hidden bg-zinc-900">
      {artist.cover_image ? (
        <>
          <img src={artist.cover_image} alt={artist.name}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-110" />
          {/* Hover overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          {/* Play button overlay */}
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            <div className="w-16 h-16 rounded-full bg-brand-pink/90 backdrop-blur-sm flex items-center justify-center shadow-2xl transform scale-50 group-hover:scale-100 transition-transform duration-500">
              <SafeIcon icon={FiPlay} className="text-white text-2xl ml-1" />
            </div>
          </div>
        </>
      ) : (
        <div className="w-full h-full flex items-center justify-center text-6xl font-black text-zinc-800 bg-gradient-to-br from-zinc-900 to-zinc-800 group-hover:from-zinc-800 group-hover:to-zinc-700 transition-colors duration-500">
          {artist.name?.[0]?.toUpperCase()}
        </div>
      )}
    </div>
    
    {/* Content */}
    <div className="p-6 space-y-4">
      <div className="space-y-2">
        <div className="flex items-center justify-between gap-2">
          <h3 className="text-lg font-black uppercase tracking-tight text-white truncate group-hover:text-brand-pink transition-colors">{artist.name}</h3>
          {artist.verified && <SafeIcon icon={FiCheckCircle} className="text-blue-500 text-lg flex-shrink-0" />}
        </div>
        <p className="text-zinc-500 text-xs font-black uppercase tracking-widest group-hover:text-zinc-400 transition-colors">{artist.genre || 'Independent'}</p>
      </div>
      
      {/* Stats */}
      <div className="flex items-center justify-between pt-2 border-t border-white/5">
        <div className="flex items-center gap-2 text-zinc-400 text-xs font-bold">
          <SafeIcon icon={FiUsers} className="text-sm" />
          <span>{(artist.supporter_count || 0).toLocaleString()}</span>
        </div>
        <div className="flex items-center gap-1.5 text-zinc-500 text-xs font-bold group-hover:text-brand-pink transition-colors">
          <SafeIcon icon={FiHeart} className="text-sm" />
          <span>Support</span>
        </div>
      </div>
    </div>
  </Link>
);

const ArtistGrid = ({ artists }) => {
  if (!artists?.length) {
    return (
      <EmptyState
        title="No artists yet"
        subtitle="Artists will appear here once they join the platform."
      />
    );
  }
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
      {artists.map((a, i) => <ArtistCard key={a.id} artist={a} index={i} />)}
    </div>
  );
};

export default ArtistGrid;